import pairs from "@/data/hreflang-pairs.json";

export interface HreflangAlternate {
  hreflang: string;
  path: string;
}

type Cluster = { en: string; es: string };

const CLUSTERS: Cluster[] = (pairs as { clusters: Cluster[] }).clusters;

const INDEX: Record<string, HreflangAlternate[]> = (() => {
  const map: Record<string, HreflangAlternate[]> = {};
  for (const c of CLUSTERS) {
    const alternates: HreflangAlternate[] = [
      { hreflang: "en-US", path: c.en },
      { hreflang: "es-US", path: c.es },
      { hreflang: "x-default", path: c.en },
    ];
    map[c.en] = alternates;
    map[c.es] = alternates;
  }
  return map;
})();

/**
 * Reciprocal hreflang alternates for a path, or an empty array when the page
 * has no translated twin. Both members of a pair return the identical set,
 * which is what Google requires for the annotation to be honoured.
 */
export const getHreflangAlternates = (rawPath: string): HreflangAlternate[] => {
  if (!rawPath) return [];
  const path =
    rawPath !== "/" && rawPath.endsWith("/") ? rawPath.slice(0, -1) : rawPath;
  return INDEX[path.toLowerCase()] ?? [];
};
